(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dron-produkt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setMain(src) {
      var main = document.getElementById('dsm-main-img');
      if (main && src) {
        main.removeAttribute('srcset');
        main.src = src;
      }
    }

    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('.dsm-thumb');
      if (thumb && thumb.dataset.src) setMain(thumb.dataset.src);
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.dsm-var-input');
      if (!input) return;
      var price = document.getElementById('dsm-price');
      var compare = document.getElementById('dsm-compare');
      var save = document.getElementById('dsm-save');
      var sticky = document.getElementById('dsm-sticky-price');
      var add = document.getElementById('dsm-add');
      if (price) price.textContent = input.dataset.price;
      if (sticky) sticky.textContent = input.dataset.price;
      if (compare) {
        compare.textContent = input.dataset.compare;
        compare.hidden = !input.dataset.compare;
      }
      if (save) {
        save.textContent = input.dataset.save;
        save.hidden = !input.dataset.save;
      }
      if (add) {
        var ok = input.dataset.available === 'true';
        add.disabled = !ok;
        add.textContent = ok ? 'Dodaj do koszyka' : 'Chwilowo niedostępny';
      }
      setMain(input.dataset.img);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
